import { render, staticRenderFns } from "./AuthGuard.vue?vue&type=template&id=379d7a8c&scoped=true&"
import script from "./AuthGuard.vue?vue&type=script&lang=js&"
export * from "./AuthGuard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379d7a8c",
  null
  
)

export default component.exports